// Mock data for FindMeAgent landing page

export const heroData = {
  title: "Find the Right Real Estate Agent",
  subtitle: "Faster, Smarter, Stress-Free",
  description: "Get matched with pre-vetted local experts. We check every agent's licence, recent sales record and client reviews, then introduce you to the 2 to 3 who know your suburb best. Free for you, no obligation.",
  imageUrl: "https://images.unsplash.com/photo-1616587896595-51352538155b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxyZWFsJTIwZXN0YXRlJTIwYWdlbnR8ZW58MHx8fHwxNzY5MjM5NjkyfDA&ixlib=rb-4.1.0&q=85"
};

export const howItWorksSteps = [
  {
    id: 1,
    title: "Tell Us About Your Property",
    description: "Enter your name, mobile, email and property address. It takes under a minute and there are no hidden fees.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "We Match You With Local Experts",
    description: "We shortlist 2 to 3 pre-vetted agents with proven recent sales in your suburb and a current licence, and call you to confirm.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Choose With Confidence",
    description: "Compare their appraisals, fees and marketing plans side by side, then choose who suits you. Walk away any time, no pressure.",
    icon: "CheckCircle"
  }
];

export const whyUseFeatures = [
  {
    id: 1,
    title: "Pre-Vetted Local Experts",
    description: "Every agent is licence-checked and screened for recent sales in your area and verified client reviews before we introduce them.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Saves Hours of Research",
    description: "Instead of calling agencies one by one, receive a ready-made shortlist of 2 to 3 suitable agents, usually within one business day.",
    icon: "Clock"
  },
  {
    id: 3,
    title: "100% Free, No Obligation",
    description: "You pay nothing to use FindMeAgent and you are never locked in. You only ever sign with an agent you choose yourself.",
    icon: "DollarSign"
  },
  {
    id: 4,
    title: "Confidential and Secure",
    description: "Your details are never sold or published. We share them only with the agents you agree to speak with.",
    icon: "Lock"
  },
  {
    id: 5,
    title: "Quick, Personal Process",
    description: "A four-field form and a short call with our team is all it takes. No apps to download, no account to create.",
    icon: "Zap"
  },
  {
    id: 6,
    title: "Real People, Real Support",
    description: "Talk to our Australian team by phone or email at any stage, from first appraisal to settlement day.",
    icon: "Heart"
  }
];

export const whoIsItFor = [
  {
    id: 1,
    title: "Homeowners Considering Selling",
    description: "Compare appraisals and commission rates from agents with proven recent sales in your suburb.",
    icon: "Home",
    image: "/images/lifestyle/family-sold-sign.jpg",
    imageAlt: "Happy family celebrating in front of their sold home"
  },
  {
    id: 2,
    title: "Buyers Looking for Local Expertise",
    description: "Work with buyer-focused agents who know local pricing, upcoming listings and the best streets.",
    icon: "Search",
    image: "/images/lifestyle/couple-keys.jpg",
    imageAlt: "Young couple holding the keys to their new home"
  },
  {
    id: 3,
    title: "Investors Seeking Market Insight",
    description: "Be matched with agents experienced in rental yields, growth suburbs and property management.",
    icon: "TrendingUp",
    image: "/images/lifestyle/investor-review.jpg",
    imageAlt: "Couple reviewing property documents with their agent"
  },
  {
    id: 4,
    title: "Families Relocating",
    description: "Get honest local advice on schools, commute times and family-friendly neighbourhoods before you move.",
    icon: "MapPin",
    image: "/images/lifestyle/family-moving.jpg",
    imageAlt: "Family unpacking boxes in their new living room"
  }
];

export const faqData = [
  {
    id: "faq-1",
    question: "Is FindMeAgent really free?",
    answer: "Yes! Our service is 100% free with no hidden costs. We're compensated by the agents in our network, so you get expert matching at no charge."
  },
  {
    id: "faq-2",
    question: "How do you select the agents you recommend?",
    answer: "We carefully vet all agents based on their experience, local market knowledge, client reviews, and professional credentials. Only trusted, proven professionals join our network."
  },
  {
    id: "faq-3",
    question: "Am I obligated to work with the agents you recommend?",
    answer: "Absolutely not. We provide you with options, and you're free to choose the agent that feels right for you — or none at all. There's zero obligation."
  },
  {
    id: "faq-4",
    question: "How quickly will I hear from an agent?",
    answer: "Typically within 24-48 hours. Our team reviews your request and connects you with suitable agents who will reach out to discuss your needs."
  },
  {
    id: "faq-5",
    question: "What information do I need to provide?",
    answer: "Just basic details: your property location, what type of service you need (buying/selling), property type, and your timeframe. It takes less than 2 minutes."
  },
  {
    id: "faq-6",
    question: "Is my information kept confidential?",
    answer: "Yes. Your information is strictly confidential and only shared with relevant agents in your area. We never sell or share your data with third parties."
  },
  {
    id: "faq-7",
    question: "What if my property is already listed?",
    answer: "If your property is currently listed with another agent, please respect that relationship. Our service is for those actively seeking new representation."
  },
  {
    id: "faq-8",
    question: "Can I request a specific type of agent?",
    answer: "Yes! In the message field of our form, you can specify any preferences such as language, experience level, or marketing style."
  }
];

// Form submission handler (mock)
export const submitFormData = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Thank you! We're matching you with the best local agents in your area." });
    }, 1000);
  });
};
